import React, { useState, useContext } from "react"
import { Grid, Radio, FormControlLabel, RadioGroup } from "@material-ui/core"
import {
    CardNumberElement,
    CardExpiryElement,
    CardCvcElement
} from '@stripe/react-stripe-js';
import Cards from 'react-credit-cards';
import 'react-credit-cards/es/styles-compiled.css';
import '../CreditCard.scss'
import FlexView from "react-flexview/lib";
import { SessionContextStore } from "../../../context/SessionContext";
import { EventEmitterService, EventKey } from "../../../services/EventEmitterService";
import { awaitWithLoading, isInFlow, HasFailedActivationInLast5Days, isCanada} from "../../../services/utils";
import { UserApi } from "../../../api/user.api";
import { BrowserView, MobileView } from "react-device-detect";
import { useLocation,  useHistory } from "react-router-dom";
import { BackButton } from "../../Core/Buttons/BackButton"
import { GreenButton } from "../../Core/Buttons/GreenButton";
import { CreditCardLogo } from "../../Core/CreditCardLogo";
import { BottomSheetPolicySummary } from '../../Insurance/BottomSheetPolicySummary';
import NewFillButton from "../../Core/NewFillButton";
import DataLayerService from "../../../services/DataLayerService";
import { InsurancePurchaseContextStore, INSURANCE_CONTEXT_ACTIONS } from "../../../context/InsuracePurchaseContext";
import { PaymentMethod } from "../../../models/user-models/CreditCardModal";
import { Action } from "../../../models/Action";
import { SessionService } from "../../../services/SessionService";
import { ErrorOutline } from '@material-ui/icons';
import SkywatchWarningText from "../../Core/SkywatchWarningText";
import { useForm } from "react-hook-form";



var classNames = require('classnames')
const ccstyle = { base: { '::placeholder': {color: 'rgb(159, 173, 197)' } } }

const CreditCard = ({stripe, elements, onPurchase,carrier}) => {
    const sessionContext = useContext(SessionContextStore)
    const purchaseContext = useContext(InsurancePurchaseContextStore)
    const location = useLocation()
    const history = useHistory()
    const [acceptTerms,setAcceptTerms] = useState(false)
    const [acceptTermsErrorTrigger,setAcceptTermsErrorTrigger] = useState(false)
    const [issuer, setIssuer] = useState('')
    const [expire, setExpire] = useState('0000')
    const [last4, setLast4] = useState('')
    const [focusedCC, setFocusedCC] = useState('number')
    const [error, setError] = useState('')
    
    const [editMode, setEditMode] = useState(!sessionContext.user.hasCreditCard)
    const [needToRenew, setneedToRenew] = useState(false)

    React.useEffect(() => {
        setEditMode(!sessionContext.user.hasCreditCard)
    }, [sessionContext.user])


    React.useEffect(() => {
        const fetchData = async () => {
            let res = await UserApi.hasFailedActivationInLast5Days()
            if(res.ok) {            
                setneedToRenew(res.data.has_failed_activation_in_last5_days)}}
        fetchData()
    }, [sessionContext.user])

    const onCreditCardNumberChange = (e) => {
        setIssuer(e.brand)
        if(e.complete) {
            const element = elements.getElement(CardExpiryElement)
            element.focus()
            setFocusedCC('expiry')
        }
    }

    const onExpiryChange = (e) => {
        if(e.complete) {
            const element = elements.getElement(CardCvcElement)
            element.focus()
            setFocusedCC('cvc')
        }
    }

    const onContinue = () => {
        if(isInFlow(location.pathname))
            EventEmitterService.dispatch(EventKey.FLOW_CC_FINISH)
    }

    const onSave = async () => {
        
        if(!stripe || !elements || (isCanada() && !acceptTerms)) {
            return
        }

        setFocusedCC('number')

        const number = elements.getElement(CardNumberElement)

        EventEmitterService.dispatch(EventKey.ShowLoader)
        let res = await stripe.createToken(number)

        if(res.error) {
            EventEmitterService.dispatch(EventKey.DismissLoader)
            setError(res.error.message)
            return false
        }

        else if(res.token) {
            let ccServerRes = await UserApi.updateCreditCard(res.token,carrier)

            EventEmitterService.dispatch(EventKey.DismissLoader)

            if(ccServerRes.ok) {
                updateCreditCardVisual(res.token.card.exp_month, res.token.card.exp_year, res.token.card.last4, res.token.card.brand)
                DataLayerService.pushToDataLayer({
                    'event': 'successful-payment-saved',
                    'payment-method': 'cc',
                })
                return true
            }
            else {
                EventEmitterService.dispatch(EventKey.ShowError, ccServerRes)
                return false
            }
        }
        else {
            EventEmitterService.dispatch(EventKey.DismissLoader)
            setError('Unknown error from credit card service provider')
            return false
        }
    }

    const setEmptyCardVisual = () => {
        setExpire("")
        setLast4("")
        setIssuer("")
    }

    const updateCreditCardVisual = (month, year, last4, brand) => {
        setExpire(`${month < 10 ? '0' : ''}${month}/${year}`)
        setLast4('************' + last4)
        setIssuer(brand)
    }

    React.useEffect(() => {
        DataLayerService.pushToDataLayer({'event': 'payment-page-loaded'})
        UserApi.getCreditCardInfo(carrier).then(res => {
            if(res.ok) {
                updateCreditCardVisual(res.parsedData.expMonth, res.parsedData.expYear, res.parsedData.lastFourDigits, res.parsedData.brand)
            }
            else {
                setEmptyCardVisual()
            }
        })
    }, [])

    const editCreditCard = () => {
        setEditMode(true)
    }

    const onEditCreditCard = async () => {
        setAcceptTermsErrorTrigger(true)
        let val = await awaitWithLoading(onSave())
        if(val) {
            setEditMode(false)
            onPurchase();
            // isInFlow(location.pathname) && onContinue()
            // EventEmitterService.dispatch(EventKey.ShowSuccess, { title: 'Credit Card Added', body: 'Credit Card saved successfully'})
        }
    }

    const onEditCreditCardAndPurache = async () => {
        setAcceptTermsErrorTrigger(true)
        let val = await awaitWithLoading(onSave())
        if(val) {
            setEditMode(false)
            onPurchase();
            let res= await awaitWithLoading(UserApi.purchaseAfterCcFailure())
            const {data: {insurance_type}} = res;
            if (res.ok) {
            history.push('/insurance/congratulations',{resp: {insuranceType: insurance_type}})
            }
            else {
                EventEmitterService.dispatch(EventKey.ShowUserError, {
                    title: "Please Note",
                    message: "Your card was declined.",
                })
            }
        }
    }

    const paymentMethodChange = (event) => {
        setEditMode(event.target.value != PaymentMethod.BANK_TRANSFER) 
        purchaseContext.dispatch(new Action(INSURANCE_CONTEXT_ACTIONS.SET_PAYMENT_METHOD, event.target.value))
    }

    return <React.Fragment>
            {SessionService.isAdmin() && isInFlow(location.pathname) && <RadioGroup onChange={paymentMethodChange} value={purchaseContext.paymentMethod}>
                <FlexView>
                    <FormControlLabel value={PaymentMethod.STRIPE} label={'Credit Card'} control={<Radio color='primary' /> } />
                    <FormControlLabel value={PaymentMethod.BANK_TRANSFER} label={'Generate policy without Credit Card'} control={<Radio color='primary' /> } />
                </FlexView>
            </RadioGroup>}
            <Grid container spacing={4} >
                <Grid item xs sm md={6}>
                    {purchaseContext.paymentMethod == PaymentMethod.STRIPE && <> 
                        {editMode && <React.Fragment>
                            <CardNumberElement onFocus={() => setFocusedCC('number')} onReady={(e) => e.focus()} 
                                options={{placeholder: 'xxxx-xxxx-xxxx-xxxx',                        
                                style: ccstyle,
                                classes: {base: 'test'}}}
                                onChange={onCreditCardNumberChange} />
                            <div className="black text-body margin-top-medium">Expiration date</div>
                            <FlexView className="margin-top-basic">
                                <div className="full-width">
                                    <CardExpiryElement onFocus={() => setFocusedCC('expiry')} onChange={onExpiryChange} options={{classes: {base: 'test'}, style: ccstyle}} />
                                </div>
                                <div className="cvc margin-left-basic full-width">
                                    <CardCvcElement onFocus={() => setFocusedCC('cvc')} options={{placeholder: 'cvc', classes: {base: 'cvc-container'}, style: ccstyle}} />
                                </div>
                            </FlexView>
                        </React.Fragment>}

                        {!editMode && <React.Fragment>
                            <FlexView vAlignContent={'center'}>
                                <CreditCardLogo brand={issuer} />
                                <div className="text-small black margin-left-6">xxxx-xxxx-xxxx-{last4.split("*")[last4.split("*").length -1]}</div>
                                <div onClick={editCreditCard} className="text-small blue clickable underline margin-left-6">Edit card</div>
                            </FlexView>
                        </React.Fragment>}
                    </>}
                    <div className="margin-top-basic">
                        <BrowserView>
                            {!isInFlow(location.pathname) && editMode && (
                            needToRenew ? <>
                                <Grid item xs={6}>
                                    <GreenButton disabled={!editMode} onClick={onEditCreditCardAndPurache}>Complete Purchase</GreenButton>
                                </Grid>
                                <Grid className="margin-top-basic margin-bottom-medium">Your credit card charge has failed and as a result, your renewal policy was not created. To finalize your purchase, please update your credit card information and click on the "complete purchase" button.</Grid>
                            </>:<>
                                <Grid item xs={6}>
                                    <NewFillButton disabled={!editMode} onClick={onEditCreditCard}>Save Changes</NewFillButton>
                                </Grid>
                            </>)}
                        </BrowserView>
                    </div>
                    {error && <div className="text-body red margin-top-basic">{error}</div>}
                </Grid>

                <Grid item xs={12} sm={6}>
                    <Cards 
                        preview={true}
                        number={"" + last4}
                        name={" "} // {sessionContext.user.firstName + " " + sessionContext.user.lastName}
                        expiry={expire}
                        cvc={'***'}
                        focused={focusedCC}
                        issuer={issuer} />
                </Grid>
            </Grid>
            <SkywatchWarningText text="Please note, if you cancel your policy before the end of the policy term, you may be charged a cancellation fee."/>
            {isCanada() && <Grid container direction='row' wrap='nowrap' spacing={1} className="margin-top-basic">
                                <Grid item>
                                    <input type='checkbox' id="terms" name="terms" onChange={() => 
                                        {
                                            setAcceptTerms(prev => !prev)
                                            setAcceptTermsErrorTrigger(true)
                                        }}/>
                                </Grid>
                                <Grid item>
                                    <label htmlFor="terms">By selecting this checkbox, I hereby agree to SkyWatch's <a target="_blank" href="https://www.skywatch.ai/terms-conditions#:~:text=THE%20SERVICES%20ARE%20PROVIDED%20ON,A%20PARTICULAR%20PURPOSE%20OR%20USE">Terms and Conditions</a> &&nbsp;
                                    <a href="https://www.skywatch.ai/privacy-policy" target="_blank">Privacy Policy</a></label>
                                    {!acceptTerms && acceptTermsErrorTrigger && <div style={{color: 'red'}}>Required</div>}
                                </Grid>
                            </Grid>}
            <BrowserView>
                {isInFlow(location.pathname) && <> 
                    <br/>
                    <FlexView className={classNames('space-between full-width margin-top-basic', {'credit-card-buttons-container': !editMode, 'credit-card-buttons-container-edit': editMode})}>
                        <BackButton />
                        <GreenButton onClick={() => editMode ? onEditCreditCard() : onPurchase()}>Complete Purchase</GreenButton>
                </FlexView>
                </>}
            </BrowserView>

            <MobileView>
                {isInFlow(location.pathname) && 
                    <BottomSheetPolicySummary title={'Complete Purchase'} onClick={() => {
                        editMode ? onEditCreditCard() : onPurchase()
                    }} /> }
                {!isInFlow(location.pathname) && editMode && (
                needToRenew ? <>
                <FlexView className="margin-top-basic" hAlignContent={'center'}>
                    <GreenButton disabled={!editMode} onClick={onEditCreditCardAndPurache}>Complete Purchase</GreenButton></FlexView>
                    <Grid className="margin-top-basic margin-bottom-medium">Your credit card charge has failed and as a result, your renewal policy was not created. To finalize your purchase, please update your credit card information and click on the "complete purchase" button.</Grid>

                </>:<><FlexView className="margin-top-basic" hAlignContent={'center'}>
                    <NewFillButton disabled={!editMode} onClick={onEditCreditCard}>Save Changes</NewFillButton>
                </FlexView></>)}
            </MobileView>
    </React.Fragment>
}

export default CreditCard;